import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bb52d3a8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bb52d3a8&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=bb52d3a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb52d3a8",
  null
  
)

export default component.exports